/**
 * Guest booking inquiry submission helpers.
 */

import { getLocalDateString } from './bookingCalendarRange';

export function formatInquiryDatesForApi(checkIn, checkOut) {
  return {
    check_in_date: getLocalDateString(checkIn),
    check_out_date: getLocalDateString(checkOut),
  };
}

export function getCreatedInquiryId(responseData) {
  if (!responseData || typeof responseData !== 'object') {
    return '';
  }
  return String(
    responseData.routing?.inquiry_id
      || responseData.inquiry?.id
      || responseData.inquiry_id
      || '',
  ).trim();
}

export function getInquiryReference(responseData) {
  if (!responseData || typeof responseData !== 'object') {
    return '';
  }
  const routingRef = String(responseData.routing?.inquiry_ref || '').trim();
  if (routingRef) {
    return routingRef;
  }
  const inquiryId = getCreatedInquiryId(responseData);
  if (!inquiryId) {
    return '';
  }
  return inquiryId.length <= 8 ? inquiryId : inquiryId.slice(0, 8);
}

export function isSuccessfulInquiryCreateResponse(responseData) {
  if (!responseData || typeof responseData !== 'object') {
    return false;
  }
  if (responseData.success === false) {
    return false;
  }
  if (!getCreatedInquiryId(responseData)) {
    return false;
  }
  if (
    responseData.routing
    && Object.prototype.hasOwnProperty.call(responseData.routing, 'routed_to_owner')
    && responseData.routing.routed_to_owner === false
  ) {
    return false;
  }
  return true;
}

export function formatInquirySuccessMessage(t, responseData) {
  const reference = getInquiryReference(responseData);
  if (reference) {
    const template = t(
      'booking.sent_with_reference',
      'Request sent. Reference: {{ref}}. The owner will respond soon.',
    );
    return template.replace(/\{\{ref\}\}/g, reference);
  }
  return t('booking.sent', 'Booking inquiry sent! The owner will respond soon.');
}

export function buildInquiryCreatePayload({
  listingId,
  checkIn,
  checkOut,
  guests,
  message,
  special_requests,
}) {
  const dates = formatInquiryDatesForApi(checkIn, checkOut);
  return {
    listing_id: listingId,
    check_in_date: dates.check_in_date,
    check_out_date: dates.check_out_date,
    guests: Number(guests) || 1,
    message: message || '',
    special_requests: special_requests || '',
  };
}
